module.exports = __webpack_public_path__ + "img/RenderG.f5c33adc.png";